/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DocumentsStatistics { 
    docClassName?: string | null;
    docClass?: number;
    currency?: string | null;
    quantity?: number;
    amount?: number;
    amountBC?: number;
    profitAmountBC?: number;
    part?: number;
}

